import { action, makeObservable, observable } from 'mobx';
import { nanoid } from 'nanoid';

import { EventEmitter } from 'src/packages/utils/event-emitter';

type TInterTableEvents = {
  onTableClick: {
    entityId: string;
  };
};

export class InterTablesInteractions {
  readonly entityId = nanoid(6);
  readonly eventEmitter: EventEmitter<TInterTableEvents>;

  @observable activeTable: string | null = null;

  constructor() {
    this.eventEmitter = new EventEmitter<TInterTableEvents>();

    makeObservable(this);
  }

  @action.bound
  setActiveTable(activeTableId: string): void {
    this.activeTable = activeTableId;
  }
}
